import Api, { configFormData } from "@/config/Api";

export default {
  getRemissions(options = {}) {
    return Api().get(`/remissions`, options);
  },

  addRemission(data) {
    return Api().post(`/remissions`, data);
  },

  getRemissionById(remissionId) {
    return Api().get(`/remissions/${remissionId}`);
  },

  updateRemissionById(remissionId, data) {
    return Api().put(`/remissions/${remissionId}`, data);
  },

  deleteRemissionById(remissionId) {
    return Api().delete(`/remissions/${remissionId}`);
  },

  sendRemissionEmail({ data }) {
    return Api().post(`/remissions/send-email`, data, configFormData);
  },

  sendRemissionSRI(data) {
    return Api().post(`/sri/signature/remission`, data);
  },

  updateRemissionStatus(data) {
    return Api().post(`/status/remissions`, data);
  },

  remissionDownload({ id }) {
    return Api().get(`/u/download/remission?id=${id}`, {
      responseType: "arraybuffer"
    });
  },
  // ════════ Métodos Batch (Optimizados para acciones masivas) ════════
  /**
   * Actualizar estado de múltiples remisiones en un lote
   * @param {Array} remissionIds - Array de IDs
   * @param {Object} statusData - Datos de estado a actualizar
   */
  updateRemissionStatusBatch(remissionIds, statusData) {
    return Api().post(`/status/remissions`, {
      remission_ids: remissionIds,
      ...statusData
    });
  }
};
